export const resolveRank = <T extends { rank?: string }>(
	parentIssue: T | undefined,
	rank: string,
): string => {
	// for the Sub-task issue types, sorting based on rank considers the parent rank first, then sorts based on item rank
	// concatenating (parentRank + rank) would do that for us!
	const parentRank = parentIssue?.rank ?? '';
	return parentRank.concat(rank);
};
